export default "__VITE_ASSET__CcvqdbqW__"